import React, { useEffect } from 'react';
import NavigationBar from '../NavigationBar';
import Footer from '../Footer';

const Page = ({ children, cls, title }) => {

  useEffect(() => {
    document.title = title;
  }, [title])

  return (
    <div className={`content ${cls}`}>
      <NavigationBar />
      {children}
      <Footer />
    </div>
  )
}

export default Page